import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Award } from "lucide-react";

export default function AdminCertificationsPage() {
    const [users, setUsers] = useState([]);
    const [certs, setCerts] = useState([]);

    useEffect(() => {
        Promise.all([
            api.get("/admin/users").then((r) => r.data),
        ]).then(async ([u]) => {
            setUsers(u);
            // fetch certs by querying each user — naive approach without a list endpoint
            const all = [];
            for (const usr of u) {
                try {
                    const { data } = await api.get(`/admin/trainee-progress/${usr.id}`);
                    if (data?.user?.id) all.push({ user: data.user, attempts: data.attempts });
                } catch {}
            }
            setCerts(all);
        });
    }, []);

    return (
        <div className="space-y-8" data-testid="admin-certifications-page">
            <div>
                <div className="font-heading text-xl text-ink-900">Certifications</div>
                <p className="text-sm text-ink-500 mt-1">The HAEVN Appointment Setter Certification is auto-issued the moment a trainee completes every module quiz at threshold.</p>
            </div>

            <div className="bg-white border border-ink-300 divide-y divide-ink-200">
                {users.filter((u) => u.role === "trainee").length === 0 && (
                    <div className="px-6 py-6 text-sm text-ink-500" data-testid="cert-trainees-empty">No trainees yet.</div>
                )}
                {users.filter((u) => u.role === "trainee").map((u) => {
                    const rec = certs.find((c) => c.user?.id === u.id);
                    const passed = rec?.attempts?.filter((a) => a.passed).length || 0;
                    return (
                        <div key={u.id} className="px-6 py-4 grid md:grid-cols-[1.5fr_1fr_120px_180px] gap-4 items-center" data-testid={`cert-trainee-${u.id}`}>
                            <div>
                                <div className="text-sm text-ink-900 font-medium">{u.name}</div>
                                <div className="text-xs text-ink-500">{u.email}</div>
                            </div>
                            <div className="text-sm text-ink-700">{u.cohort || <span className="text-ink-400">—</span>}</div>
                            <div className="text-xs font-mono uppercase tracking-[0.15em] text-ink-500">{passed} passed</div>
                            <div>
                                <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.15em] font-mono text-ink-500">
                                    <Award size={12} /> Auto-issued on 100%
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
